<template>
  <v-app id="inspire">
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'app',
  created() {
    document.title = "CUPE Part-Time Job Application Portal"
  }
}
</script>

<style>  
</style>